/** Navigation du plugin Studio (pur : aucun composant). Contrat : horaliia `frontend/src/shared/plugins.ts`. */
import { ProfilEnum } from '@/shared/types/user';

export const pages = [
  { path: '/admin/studio', family: 'supervision', label: 'Studio', icon: 'bi-diagram-2', profils: [ProfilEnum.CADRE, ProfilEnum.ADMIN] },
];
